export default [
    {
        path: '/integralMall',
        name: 'IntegralMall',
        meta: { login: true, title: '积分兑换商城' },
        component: () => import(/* webpackChunkName: 'integralMall' */ './page/index.vue'),
    },
    {
        path: '/points-for-goods/detail',
        name: 'PointsForGoods',
        meta: { login: true, title: '积分兑换商品详情'},
        component: () => import(/* webpackChunkName: 'integralMall' */ './page/detail.vue'),
    },
  ]